import * as yup from 'yup'
import { omitIf } from '@/utils/misc.js'

// NOTE: array().ensure() does not work (see https://github.com/jquense/yup/pull/347)
const ensure = (val, orig) => {
  const value = val || orig
  return (value === null ? undefined : [].concat(value))
}

const SCHEMAS = {
  'search-form': yup.object({
    term: yup.string().min(1).required(),
    titles: yup.array().of(yup.string()),
    page: yup.number().integer(),
    range: yup.array().of(yup.string()),
    fuzziness: yup.number().integer().default(1),
    view: yup.string().oneOf(['combined', 'text','image']).default('combined'),
    h_0: yup.array().of(yup.string()),
    h_1: yup.array().of(yup.string()),
    h_2: yup.array().of(yup.string()),
  }),
  'tagsearch-form': yup.object({
    value: yup.string(),
    type : yup.array().of(yup.string()),
    page: yup.number().integer(),
  }),
  paginated: yup.object({
    page: yup.number().integer()
  }),
  browser: yup.object({
    display: yup.string().oneOf(['aside', 'overlay']).required().default('aside'),
    tag: yup.string().oneOf(['showtags', 'hidetags']).required().default('showtags'),
    textVisible: yup.boolean().required().default(false),
    term: yup.string(),
    fuzziness: yup.number().integer().default(1),
    h_0: yup.array().of(yup.string()),
    h_1: yup.array().of(yup.string()),
    h_2: yup.array().of(yup.string()),
  })
}

function createValidator(schemaName) {
  if (!(schemaName in SCHEMAS)) {
    throw new Error(`'${schemaName}' not in schemas`)
  }
  const schema = SCHEMAS[schemaName]
  return {
    isValid(data) {
      return schema.isValidSync(data)
    },
    clean(data, { omitEmpty = true } = {}) {
      const result = schema.cast(data, {
	abortEarly: false,
	strict: false,
	stripUnknown: false
      }) 
      return omitEmpty === true ? omitIf(result, (value) => ((value instanceof Array) && (value.length === 0)) || value === undefined) : result
    },
    getDefault(fieldName) {
      const field = schema.fields[fieldName]

      if (field && typeof field.default === 'function') {
	const val = field.default()
	if (val === undefined) {
	  return null
	}
	return field.default()
      }
      return null
    }
  }
}

export {
  createValidator
}

{
  const v = createValidator('search-form')
  console.assert(v.isValid({ term: '' }) === false)
  console.assert(v.isValid({ term: 'persaler' }) === true)
  console.assert(v.clean({ term: 'persaler' }))
}

